import React, { useEffect, useState } from 'react'
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);
const Display = () => {
    const [salaryData, setSalaryData] = useState({
        country: "1",
        perdayrate: 2400,
        payable_days: 25,
        monthly: 60000,
        annually: 720000,
        employer: [
          { bname: "Provident Fund", month: 1800, yearly: 21600 },
          { bname: "Employee's State Insurance", month: 683, yearly: 8190 },
        ],
        employer_contribution: { bname: "Total Contribution", month: 2483, year: 29790 },
        employer_tcost: { bname: "Total Cost", month: 62483, year: 749790 },
        employee: [
          { bname: "PF", month: 1800, yearly: 21600 },
          { bname: "Employee's State Insurance", month: 158, yearly: 1890 },
          { bname: "tax", month: 2250, yearly: 27000 },
        ],
        employee_contribution: { bname: "Total contribution", month: 4207.5, year: 50490 },
        employee_tcost: { bname: "Total Net Pay", month: 55793, year: 669510 },
      });
    // Pie chart data
    const [employerChartData, setEmployerChartData] = useState({
        labels: [],
        datasets: [
          {
            label: 'Employer Annual Breakdown',
            data: [],
            backgroundColor: [],
            borderColor: [],
            borderWidth: 1,
          },
        ],
      });
    
      const [employeeChartData, setEmployeeChartData] = useState({
        labels: [],
        datasets: [
          {
            label: 'Employee Annual Breakdown',
            data: [],
            backgroundColor: [],
            borderColor: [],
            borderWidth: 1,
          },
        ],
      });
    
   // Function to generate random colors
const generateRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  // Update chart data whenever salaryData changes
  useEffect(() => {
    // Employer Pie Chart Data
    const employerLabels = salaryData.employer.map(item => item.bname);
    employerLabels.push("Gross Salary");
    const employerData = salaryData.employer.map(item => item.yearly);
    employerData.push(salaryData.annually);
    const employerColors = employerLabels.map(() => generateRandomColor());
    

  setEmployerChartData((prevData) => ({
    ...prevData,
    labels: employerLabels,
    datasets: [
      {
        ...prevData.datasets[0],
        data: employerData,
        backgroundColor: employerColors,
        //borderColor: employerColors.map(color => color), // Apply the same color to borders
        borderColor: 'white', // Set border color to white
        borderWidth: 1, // Width for visibility
      },
    ],
  }));

    // Employee Pie Chart Data
    const employeeLabels = salaryData.employee.map(item => item.bname);
    employeeLabels.push("Gross Salary");
    const employeeData = salaryData.employee.map(item => item.yearly);
    employeeData.push(salaryData.annually);
      // Generate valid dynamic colors for employee chart
  const employeeColors = employeeLabels.map(() => generateRandomColor());

  setEmployeeChartData((prevData) => ({
    ...prevData,
    labels: employeeLabels,
    datasets: [
      {
        ...prevData.datasets[0],
        data: employeeData,
        backgroundColor: employeeColors,
        borderColor: 'white', // Set border color to white
        borderWidth: 1, // Width for visibility
      },
    ],
  }));
}, [salaryData]);


  return (
    <>
        <div className='display-block'>
            <div className='display-section'>
                <div className='wrapper'>
                    <div className='container'>
                        <div className='row'>
                            <div className='panel-heading'>
                                <p>Global Payroll</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className='banner-section'>
            <div className='container'>
                    <div className='row'>
                        <div className='banner-heading'>
                            <p>Basic Information</p>
                            <div className='gridStyleCountry'>
                            <div className="header">Country</div>
                            <div className="header-v">{salaryData.country}</div>
                            <div className="header">Per Day Rate</div>
                            <div className="header-v">₹{salaryData.perdayrate}</div>
                            <div className="header">Payable Days</div>
                            <div className="header-v">{salaryData.payable_days}</div>
                            <div className="header">Monthly Salary</div>
                            <div className="header-v">₹{salaryData.monthly}</div>
                            <div className="header">Annual Salary</div>
                            <div className="header-v">₹{salaryData.annually}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className='calculation_display'>
            <div class='container'>
                <div class='row'>
                    <div className="col-lg-6">
                        <div className='gross-section'>
                            <div className='wrapper'>
                                <div className='container'>
                                    <div className='row'>
                                        <p className="calc-head">Employer Cost</p>
                                        <div className='col-lg-12'>
                                            <div className='gridStyle'>
                                                <div className="header text-start fw-bold">Benefit</div>
                                                <div className="header fw-bold text-end">Monthly (₹)</div>
                                                <div className="header text-end fw-bold">Yearly (₹)</div>
                                                <div className='text-start fw-bold'>Gross Salary</div> 
                                                <div className='text-end'>{salaryData.monthly}</div> 
                                                <div className='text-end'>{salaryData.annually}</div>
                                                {salaryData.employer.map((item, index) => (
                                                    <>
                                                <div className='text-start fw-bold' key={`${item.bname}-name`}>{item.bname}</div>
                                                <div className='text-end' key={`${item.bname}-month`}>{item.month}</div>
                                                <div className="text-end"key={`${item.bname}-yearly`}>{item.yearly}</div>
                                                    </>
                                                ))}
                                                <div className='text-start fw-bold'>{salaryData.employer_contribution.bname}</div>
                                                <div className='text-end'>{salaryData.employer_contribution.month}</div>
                                                <div className='text-end'>{salaryData.employer_contribution.year}</div>
                                                <div className='text-start fw-bold'>{salaryData.employer_tcost.bname }</div>
                                                <div className='text-end fw-bold'>{salaryData.employer_tcost.month}</div>
                                                <div className='text-end fw-bold'>{salaryData.employer_tcost.year}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className='gross-right-section'>
                            <div className='wrapper'>
                                <div className='container'>
                                    <div className='row'>
                                    <p className="calc-head">Employee Net Salary</p>
                                        <div className='col-lg-12'>
                                        <div className='gridStyle'>
                                                <div className="header text-start fw-bold">Benefit</div>
                                                <div className="header fw-bold text-end">Monthly (₹)</div>
                                                <div className="header text-end fw-bold">Yearly (₹)</div>
                                                <div className='text-start fw-bold'>Gross Salary</div> 
                                                <div className='text-end'>{salaryData.monthly}</div> 
                                                <div className='text-end'>{salaryData.annually}</div>
                                                {salaryData.employee.map((item, index) => (
                                                    <>
                                                <div className='text-start fw-bold' key={`${item.bname}-name`}>{item.bname}</div>
                                                <div className='text-end' key={`${item.bname}-month`}>{item.month}</div>
                                                <div className="text-end"key={`${item.bname}-yearly`}>{item.yearly}</div>
                                                    </>
                                                ))}
                                                <div className='text-start fw-bold'>{salaryData.employee_contribution.bname}</div>
                                                <div className='text-end'>{salaryData.employee_contribution.month}</div>
                                                <div className='text-end'>{salaryData.employee_contribution.year}</div>
                                                <div className='text-start fw-bold'>{salaryData.employee_tcost.bname }</div>
                                                <div className='text-end fw-bold'>{salaryData.employee_tcost.month}</div>
                                                <div className='text-end fw-bold'>{salaryData.employee_tcost.year}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
         {/* Pie Chart Components */}
         <div className='chart-own'>
            <div className="charts-section">
                <div className='wrapper'>
                    <div className="container">
                        <div className="row">
                            {/* Employer Annual Breakdown Pie Chart */}
                            <div className="col-lg-6">
                                <h6 className='text-center'>Employer Annual Breakdown</h6>
                                <div className="chart-container">
                                <Pie 
                                    data={employerChartData} 
                                    options={{ 
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                        position: 'top',
                                        },
                                    },
                                    layout: {
                                        padding: 20,
                                    },
                                    }} 
                                    height={250}
                                    width={250}
                                />
                                </div>
                            </div>

                            {/* Employee Annual Breakdown Pie Chart */}
                            <div className="col-lg-6">
                                <h6 className='text-center'>Employee Annual Breakdown</h6>
                                <div className="chart-container">
                                <Pie 
                                    data={employeeChartData} 
                                    options={{ 
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                        position: 'top',
                                        },
                                    },
                                    layout: {
                                        padding: 20,
                                    },
                                    }} 
                                    height={250}
                                    width={250}
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </div>
    </>
  )
}

export default Display